import { render, staticRenderFns } from "./Students.vue?vue&type=template&id=49fdb133&scoped=true"
import script from "./Students.vue?vue&type=script&lang=js"
export * from "./Students.vue?vue&type=script&lang=js"
import style0 from "./Students.vue?vue&type=style&index=0&id=49fdb133&prod&lang=scss"
import style1 from "./Students.vue?vue&type=style&index=1&id=49fdb133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fdb133",
  null
  
)

export default component.exports